import { NgModule } from '@angular/core';
import { UnitConversionPipe } from './unit-conv.pipe';

@NgModule({
  declarations: [UnitConversionPipe],
  providers: [UnitConversionPipe],
  exports: [UnitConversionPipe]
})
export class UnitConversionPipeModule { }
